/**
 * Strips any absolute origin from a booking link so the browser uses the
 * current host (e.g. localhost:3000 in dev, millionspaces.com in prod).
 */
export const toRelativeBookingPath = (value) => {
  if (!value || typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;

  if (!/^https?:\/\//i.test(trimmed)) {
    return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  }

  try {
    const { pathname, search } = new URL(trimmed);
    return `${pathname}${search}`;
  } catch {
    return null;
  }
};

const hasUrlTimeParams = (url) => /(?:^|[?&])urlStartTime=/i.test(url || '');

/**
 * Prefer a client-built URL when it carries time params, otherwise prefer the
 * API link only when no richer fallback exists. This keeps agent card "Book Now"
 * links aligned with the booking page's expected query shape.
 */
export const resolveSpaceCardBookingUrl = (space, fallback) => {
  const built = typeof fallback === 'function' ? fallback() : null;
  const fromApi = toRelativeBookingPath(space?.bookingUrl);

  if (built && hasUrlTimeParams(built)) {
    return built;
  }
  if (fromApi && hasUrlTimeParams(fromApi)) {
    return fromApi;
  }
  if (built) {
    return built;
  }
  return fromApi;
};
